// extracted by mini-css-extract-plugin
module.exports = {"mobile":"AccountMenu_mobile__1LQQU","menu":"AccountMenu_menu__3v9Z_","active":"AccountMenu_active__1wdaA"};